<template>
  <b-card body>
    <div class="d-flex justify-between">
      <div class="d-flex w-50 align-items-start">
        <b-button
          variant="primary"
          size="sm"
          class="mr-1 rounded-lg p-0"
          @click="$router.go(-1)"
        >
          <feather-icon
            size="2x"
            icon="ChevronLeftIcon"
          />
        </b-button>
        <div class="text-black font-semibold text-2xl">
          Stok Gudang
        </div>
      </div>
      <b-button
        variant="primary"
        class="!flex items-center gap-[8px] px-1 rounded-lg font-bolder"
        :disabled="loadingExport"
        @click="exportStock"
      >
        <template>
          <span>Export Stock</span>
          <div class="size-[20px] flex items-center justify-center">
            <img
              v-if="!loadingExport"
              src="@/assets/images/svg/export.svg"
              alt="export"
            >
            <b-spinner
              v-else
              small
              class="!-mt-[5px]"
            />
          </div>
        </template>
      </b-button>
    </div>
    <b-row>
      <b-col
        lg="12"
        md="12"
      >
        <div class="my-2 p-2 border rounded-lg text-black">
          <div class="mb-1 flex gap-x-4">
            <b-img
              rounded="circle"
              :src="partnerLogo"
              alt="logo"
              style="width: 48px; height: 48px"
            />
            <div class="align-self-center">
              <div class="font-semibold">
                {{ partnerName }}
              </div>
              <div class="">
                {{ partnerApprovedDate }}
              </div>
            </div>
          </div>
          <b-row class="">
            <b-col
              md="3"
              lg="2"
            >
              <p>Sektor Bisnis</p>
              <p>Tipe Bisnis</p>
            </b-col>
            <b-col
              md="4"
              lg="5"
            >
              <p>{{ dataPartner.business_sector || '-' }}</p>
              <p>{{ dataPartner.business_type || '-' }}</p>
            </b-col>
            <b-col
              md="3"
              lg="2"
            >
              <p>Jumlah Produk</p>
              <p>Total Terjual</p>
            </b-col>
            <b-col
              md="2"
              lg="1"
            >
              <p>{{ dataPartner.product_total }}</p>
              <p>{{ dataPartner.total_sold }}</p>
            </b-col>
            <b-col
              md="12"
              lg="2"
            >
              <b-button
                size="sm"
                variant="outline-primary"
                style="height: 38px;"
                @click="chatButton(dataPartner.number_phone)"
              >Chat Partner
              </b-button>
            </b-col>
          </b-row>
        </div>

        <div class="flex justify-between items-center gap-[16px] flex-wrap">
          <b-form-checkbox
            v-model="hideEmptyStock"
            class="custom-control-primary mb-2"
          >
            <span class="text-[#222222]">Sembunyikan Stok 0</span>
          </b-form-checkbox>
          <b-button
            v-b-modal.modal-download-riwayat-stok
            variant="primary"
            class="mb-2"
          >
            <i
              class="k-document-download mr-[8px]"
            />
            Download Riwayat Stock
          </b-button>
        </div>

        <modal-download-riwayat-stok
          :partner-id="dataPartner.id"
          :produk="productOptions"
          :is-loading="loading"
        />

        <b-overlay
          spinner-variant="primary"
          variant="light"
          blur="0"
          opacity=".5"
          rounded="sm"
          :show="loading"
        >
          <b-table
            :fields="columnConfig"
            :items="items"
            responsive
            show-empty
          >
            <template #empty>
              <div
                v-if="isLoadingProducts"
                class="text-center text-[#F95031] my-[16px] flex items-center justify-center gap-[8px]"
              >
                <b-spinner
                  small
                  class="align-middle"
                />
                <span>memuat data...</span>
              </div>
              <p
                v-else
                class="text-center text-[#828282] my-[16px] flex items-center justify-center gap-[8px]"
              >
                Tidak ada data yang ditampilkan.
              </p>
            </template>
            <template #cell(product_name)="data">
              <div class="flex gap-x-3">
                <img
                  :src="data.item.image_url || 'https://storage.googleapis.com/komerce/assets/icons/product-placehold.svg'"
                  alt="image"
                  width="48"
                  height="48"
                  class="object-contain"
                  @error="handleImageError"
                >
                <div class="">
                  <div class="">
                    {{ data.item.product_name }}
                  </div>
                  <small class="text-primary">SKU : {{ data.item.sku || '-' }}</small>
                </div>
              </div>
            </template>
            <template #cell(variant)="data">
              <div v-if="data.item.variants && data.item.variants.length > 0">
                <div
                  class="mb-50"
                >
                  <span v-b-tooltip.hover.top="showVariantNameTooltip(data.item.variants[0].name) ? data.item.variants[0].name : null">{{ truncateWithEllipsis(data.item.variants[0].name) }}</span>
                </div>
                <BCollapse :id="`collapse-${String(data.index)}`">
                  <div
                    v-for="(item, idx) in data.item.variants.slice(1)"
                    :key="idx"
                    class="mb-50"
                  >
                    <span v-b-tooltip.hover.top="showVariantNameTooltip(item.name) ? item.name : null">{{ truncateWithEllipsis(item.name) }}</span>
                  </div>
                </BCollapse>
              </div>
              <div
                v-else
                class="mt-1"
              >
                -
              </div>
              <div
                v-if="itemHadVariant(data.item)"
                v-b-toggle="`collapse-${String(data.index)}`"
                variant="flat-dark"
                size="sm"
                class="mt-1 flex items-center justify-end"
              >
                <span
                  class="when-opened"
                >
                  Tutup
                </span>
                <span
                  class="when-closed"
                >
                  Tampilkan Variasi
                </span>
                <feather-icon
                  icon="ChevronDownIcon"
                  class="when-closed"
                />
                <feather-icon
                  icon="ChevronUpIcon"
                  class="when-opened"
                />
              </div>
            </template>
            <template #cell(stock)="{ index, item }">
              <div v-if="item.variants && item.variants.length > 0">
                <div
                  class="mb-50"
                >
                  <span>{{ item.variants[0].stock }}</span>
                </div>
                <BCollapse :id="`collapse-${index}`">
                  <div
                    v-for="(itemVariant, idx) in item.variants.slice(1)"
                    :key="idx"
                    class="mb-50"
                  >
                    {{ itemVariant.stock }}
                  </div>
                </BCollapse>
              </div>
              <div
                v-else
                class="mt-1"
              >
                {{ item.stock || 0 }}
              </div>
            </template>
            <template #cell(packing_material)="{ item }">
              <ul class="list-disc">
                <li
                  v-for="(pm, index) in item.packings"
                  :key="index"
                >
                  {{ pm.name }} ({{ pm.layer }})
                </li>
              </ul>
            </template>
            <template #cell(fulfillment_fee)="{ item }">
              <div class="">
                {{ fulfillmentCostDetail(item) }}
              </div>
            </template>
            <template #cell(sold)="{ index, item }">
              <div v-if="item.variants && item.variants.length > 0">
                <div
                  class="mb-50"
                >
                  <span>{{ item.variants[0].sold }}</span>
                </div>
                <BCollapse :id="`collapse-${index}`">
                  <div
                    v-for="(itemVariant, idx) in item.variants.slice(1)"
                    :key="idx"
                    class="mb-50"
                  >
                    {{ itemVariant.sold === null ? 0 : itemVariant.sold }}
                  </div>
                </BCollapse>
              </div>
              <div
                v-else
                class="mt-1"
              >
                {{ item.sold || 0 }}
              </div>
            </template>
            <template #cell(product_dimension)="{ item }">
              <div
                v-if="item.product_length || item.product_width || item.product_height"
                class="space-y-1"
              >
                <div class="flex space-x-1">
                  <span class="shrink-0">P:</span>
                  <span>{{ item.product_length ? `${item.product_length} cm` : '-' }}</span>
                </div>
                <div class="flex space-x-1">
                  <span class="shrink-0">L:</span>
                  <span>{{ item.product_width ? `${item.product_width} cm` : '-' }}</span>
                </div>
                <div class="flex space-x-1">
                  <span class="shrink-0">T:</span>
                  <span>{{ item.product_height ? `${item.product_height} cm` : '-' }}</span>
                </div>
              </div>
              <div v-else>
                -
              </div>
            </template>
            <template #row-details="{ index, item }">
              <b-row
                class="-mt-[1rem] pl-[4.3rem]"
              >
                <b-col cols="12">
                  <div class="flex">
                    <div
                      v-b-toggle="`bundling-${index}`"
                      class="flex items-center gap-[4px] py-[4px] px-[8px] rounded-[12px] !bg-[#08A0F7] text-white font-[500] cursor-pointer"
                    >
                      <img
                        src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/gift.svg"
                        alt="bundling"
                        width="16"
                      >
                      <div>Bundling {{ item.is_variant_bundle ? 'Varian' : '' }}</div>
                    </div>
                  </div>
                  <b-collapse
                    :id="`bundling-${index}`"
                  >
                    <div class="border-l-[2px] h-min p-[16px] ml-[3.5rem]">
                      <BundleVarianComponentDetails
                        v-if="item.is_variant_bundle"
                        :items="item.product_variant_bundle"
                        class-container="border rounded-t w-[92%]"
                        component-location="components"
                        :additional-fields="fulfillmentCostFields"
                      />
                      <div
                        v-else
                        class="border rounded-t w-[70%]"
                      >
                        <div class="bg-[#FFECE9] py-[8px] px-[24px] rounded-t text-black font-[500]">
                          Produk
                        </div>
                        <b-table
                          :items="item.product_bundle"
                          :fields="fieldsBundling"
                        >
                          <template #cell(no)="bundle">
                            {{ bundle.index + 1 }}
                          </template>
                          <template #cell(product_name)="bundle">
                            <div class="flex gap-[16px] items-start">
                              <img
                                :src="bundle.item.image_url || 'https://storage.googleapis.com/komerce/assets/icons/product-placehold.svg'"
                                alt="product"
                                width="52"
                                height="52"
                                @error="handleImageError"
                              >
                              <div class="space-y-[4px]">
                                <div class="text-[16px]">
                                  {{ bundle.item.product_name }}
                                </div>
                                <div class="text-[14px]">
                                  SKU: {{ bundle.item.sku || '-' }}
                                </div>
                              </div>
                            </div>
                          </template>
                        </b-table>
                      </div>
                    </div>
                    <div class="flex ml-[0.8rem]">
                      <div
                        v-b-toggle="`bundling-${index}`"
                        class="flex items-center gap-[4px] py-[4px] px-[8px] rounded-[12px] !bg-[#F95031] text-white font-[500] cursor-pointer"
                      >
                        <feather-icon
                          icon="ChevronUpIcon"
                        />
                        <div>Tutup</div>
                      </div>
                    </div>
                  </b-collapse>
                </b-col>
              </b-row>
            </template>
          </b-table>
        </b-overlay>
      </b-col>
    </b-row>

    <LoadMoreData :fetcher="fetcherProducts" />
  </b-card>
</template>

<script>
import filters from '@/libs/filters'
import chatButton from '@/libs/chatButton'
import { DAY_MONTH_YEAR } from '@/libs/filterDate'
import { toastError, toastSuccess } from '@/libs/toastification'
import { createPaginatedFetcher } from '@/@core/libs/fetch/usePaginatedFetcher'
import BundleVarianComponentDetails from '@/views/pages/kompack/storage-request/detail/BundleVarianComponentDetails.vue'
import axios from 'axios'
import { mapState } from 'vuex'
import { columnConfig, fieldsBundling, STOCK_MAP_KEYS } from './config'
import ModalDownloadRiwayatStok from './ModalDownloadRiwayatStok.vue'
import LoadMoreData from '../../outbound/non-komship/LoadMoreData.vue'

export default {
  components: {
    ModalDownloadRiwayatStok,
    LoadMoreData,
    BundleVarianComponentDetails,
  },
  data() {
    return {
      chatButton,
      DAY_MONTH_YEAR,
      columnConfig,
      partnerId: this.$route.params.id,
      dataPartner: this.$route.params.datapartner,
      loading: false,
      loadingExport: false,
      fieldsBundling,
      fetcherProducts: null,
      hideEmptyStock: false,
    }
  },
  computed: {
    ...mapState('warehouse', ['profile']),
    warehouseId() {
      return this.profile?.id || null
    },
    /**
     * Map of standalone products and variants stock for bundle stock recalculation
     */
    baseStockMap() {
      const rawData = this.fetcherProducts?.data
      const stockMap = new Map()
      if (!Array.isArray(rawData) || rawData.length === 0) return stockMap

      for (let i = 0; i < rawData.length; i += 1) {
        const item = rawData[i]
        if (!item.is_bundling && !item.is_variant_bundle) {
          const pId = item.product_id || item.id
          const { variants } = item

          if (Array.isArray(variants) && variants.length > 0) {
            let totalVariantsStock = 0
            for (let j = 0; j < variants.length; j += 1) {
              const variant = variants[j]
              const stock = Number(variant?.stock) || 0
              totalVariantsStock += stock
              if (pId && variant.name) {
                stockMap.set(STOCK_MAP_KEYS.productVariant(pId, variant.name), stock)
              }
              if (variant.id) {
                stockMap.set(STOCK_MAP_KEYS.variantId(variant.id), stock)
              }
            }
            if (pId) {
              stockMap.set(STOCK_MAP_KEYS.product(pId), totalVariantsStock)
            }
          } else {
            const stock = Number(item.stock) || 0
            if (pId) {
              stockMap.set(STOCK_MAP_KEYS.product(pId), stock)
            }
          }
        }
      }

      return stockMap
    },
    /**
     * Cache processed products with recalculated bundle stocks
     */
    processedProducts() {
      const rawData = this.fetcherProducts?.data
      if (!Array.isArray(rawData) || rawData.length === 0) return []

      const stockMap = this.baseStockMap

      return rawData.map(item => {
        let { stock } = item
        let variants = Array.isArray(item.variants) ? [...item.variants] : []
        let productVariantBundle = item.product_variant_bundle

        if (item.is_bundling) {
          stock = this.calculateBundleStock(item.product_bundle, stockMap)
        } else if (item.is_variant_bundle) {
          const bundleResult = this.calculateVariantBundle(item.product_variant_bundle, stockMap)
          productVariantBundle = bundleResult.productVariantBundle
          variants = bundleResult.variants
          stock = bundleResult.totalStock
        }

        return {
          ...item,
          stock,
          variants,
          product_variant_bundle: productVariantBundle,
          _showDetails: item.is_bundling || item.is_variant_bundle,
        }
      })
    },
    items() {
      if (!this.hideEmptyStock) {
        return this.processedProducts
      }
      return this.processedProducts.filter(item => this.hasStock(item))
    },
    isLoadingProducts() {
      return this.fetcherProducts?.isLoading || false
    },
    // computed product options
    productOptions() {
      const result = {
        text: [],
        value: [],
      }
      this.items.forEach(v => {
        if (!v.is_bundling) {
          result.text.push(v.product_name)
          result.value.push(v.id)
        }
      })
      return result
    },
    // computed partner logo with fallback image
    partnerLogo() {
      return this.dataPartner?.image_logo_url || 'https://storage.googleapis.com/komerce/assets/icons/product-placehold.svg'
    },
    partnerName() {
      return this.dataPartner?.name || '-'
    },
    partnerApprovedDate() {
      return this.dataPartner?.approved_date ? DAY_MONTH_YEAR(this.dataPartner?.approved_date) : '-'
    },
    fulfillmentCostFields() {
      return [
        {
          key: 'fulfillment_cost',
          label: 'Biaya Fulfillment',
          thClass: 'font-[500] text-[#222] !text-[14px] !capitalize bg-white min-w-[180px]',
          tdClass: 'text-black',
          formatter: value => filters.rupiah(value),
        },
      ]
    },
  },
  /**
   * Check if data partner is undefined
   * If true, redirect to previous page
   * If false, get product list
   */
  async created() {
    if (this.dataPartner === undefined) {
      this.$router.go(-1)
      return
    }
    this.initializeFetcherProducts()
    if (!this.profile) {
      try {
        await this.$store.dispatch('warehouse/getWarehouseProfile')
      } catch (error) {
        toastError('Gagal mengambil profil gudang, silahkan coba lagi')
      }
    }
    this.fetcherProducts.fetchData({
      reset: true,
    })
  },
  methods: {
    truncateWithEllipsis(text) {
      return text?.length <= 10 ? text : `${text?.slice(0, 10)}...`
    },
    handleImageError(event) {
      const ev = event.target
      ev.src = 'https://storage.googleapis.com/komerce/assets/icons/product-placehold.svg'
    },
    /**
     * Initialize fetcher products with pagination
     */
    initializeFetcherProducts() {
      const fnFetch = ({
        offset, limit,
      }) => {
        if (!this.warehouseId) {
          return Promise.resolve({ data: [] })
        }
        const params = {
          page: offset,
          limit,
          for_non_pickup: 1, // include bundle varian product
        }
        return this.$http_new.get(`/komship/api/v1/product-warehouses/partners/${this.partnerId}/warehouses/${this.warehouseId}/fulfillment-cost`, {
          params,
        })
          .then(response => {
            const { data, code } = response.data

            if (code === 400) {
              throw new Error(response.data.message)
            }

            return { data }
          })
          .catch(err => {
            if (axios.isCancel(err) || err.name === 'AbortError' || err.code === 'ERR_CANCELED') {
              throw err
            }
            toastError('Gagal mengambil data stok gudang, silahkan coba lagi')
            return { data: [] }
          })
      }
      this.fetcherProducts = createPaginatedFetcher(fnFetch, 0, 50)
    },
    /**
     * Look up available stock for a component from the base stock map
     */
    lookupComponentStock(component, stockMap) {
      if (!stockMap || !(stockMap instanceof Map)) {
        return Number(component?.stock) || 0
      }

      const pId = component.product_id || component.id
      const variantName = component.variant_name && component.variant_name !== '-' ? component.variant_name : null

      // If component itself contains a list of variants, sum their stocks
      if (Array.isArray(component.variants) && component.variants.length > 0) {
        let sum = 0
        for (let i = 0; i < component.variants.length; i += 1) {
          const v = component.variants[i]
          sum += this.lookupComponentStock({
            ...v,
            product_id: pId,
            variant_name: v.name,
          }, stockMap)
        }
        return sum
      }

      if (variantName && pId) {
        const val = stockMap.get(STOCK_MAP_KEYS.productVariant(pId, variantName))
        if (val !== undefined) return val
      }

      const vId = component.variant_id || component.id
      if (vId) {
        const val = stockMap.get(STOCK_MAP_KEYS.variantId(vId))
        if (val !== undefined) return val
      }

      if (pId) {
        const val = stockMap.get(STOCK_MAP_KEYS.product(pId))
        if (val !== undefined) return val
      }

      if (component.stock !== undefined && component.stock !== null) {
        return Number(component.stock) || 0
      }

      return 0
    },
    /**
     * Calculate stock for a standard bundling product with early exit
     */
    calculateBundleStock(productBundle, stockMap) {
      if (!Array.isArray(productBundle) || productBundle.length === 0) {
        return 0
      }

      let minStock = Infinity
      for (let i = 0; i < productBundle.length; i += 1) {
        const comp = productBundle[i]
        const availableStock = this.lookupComponentStock(comp, stockMap)
        const requiredQty = Number(comp?.qty) > 0 ? Number(comp.qty) : 1
        const bundleCount = Math.floor(availableStock / requiredQty)
        if (bundleCount === 0) return 0
        if (bundleCount < minStock) {
          minStock = bundleCount
        }
      }

      return minStock === Infinity ? 0 : minStock
    },
    /**
     * Calculate stock for each variant in a bundle variant product in a single pass
     */
    calculateVariantBundle(productVariantBundle, stockMap) {
      if (!Array.isArray(productVariantBundle) || productVariantBundle.length === 0) {
        return { productVariantBundle: [], variants: [], totalStock: 0 }
      }

      let totalStock = 0
      const len = productVariantBundle.length
      const variants = new Array(len)
      const updatedBundle = new Array(len)

      for (let i = 0; i < len; i += 1) {
        const variant = productVariantBundle[i]
        const { components } = variant
        let variantStock = 0

        if (Array.isArray(components) && components.length > 0) {
          let minCompStock = Infinity
          for (let j = 0; j < components.length; j += 1) {
            const comp = components[j]
            const stock = this.lookupComponentStock(comp, stockMap)
            const requiredQty = Number(comp?.qty) > 0 ? Number(comp.qty) : 1
            const count = Math.floor(stock / requiredQty)
            if (count === 0) {
              minCompStock = 0
              break
            }
            if (count < minCompStock) {
              minCompStock = count
            }
          }
          variantStock = minCompStock === Infinity ? 0 : minCompStock
        }

        totalStock += variantStock
        variants[i] = {
          id: variant.product_variant_bundle_id,
          name: variant.variant_name,
          stock: variantStock,
          sold: variant.sold ?? 0,
        }
        updatedBundle[i] = {
          ...variant,
          stock: variantStock,
        }
      }

      return {
        productVariantBundle: updatedBundle,
        variants,
        totalStock,
      }
    },
    /**
     * Check if item has available stock (including variants check)
     */
    hasStock(item) {
      if (Array.isArray(item?.variants) && item.variants.length > 0) {
        return item.variants.some(variant => Number(variant?.stock) > 0)
      }
      return Number(item?.stock) > 0
    },
    /**
     * Check if item has variant
     */
    itemHadVariant(item) {
      return item?.variants?.length > 1
    },
    /**
     * Check if variant name is too long
     */
    showVariantNameTooltip(variantName) {
      return variantName?.length >= 10
    },
    /**
     * Display range of fulfillment cost when its bundle varian product
     */
    fulfillmentCostDetail(item) {
      if (item.is_variant_bundle && (item.fulfillment_cost_min !== item.fulfillment_cost_max)) return `${filters.rupiah(item.fulfillment_cost_min)} - ${filters.rupiah(item.fulfillment_cost_max)}`
      return `${filters.rupiah(item.fulfillment_cost || item.fulfillment_cost_min)}`
    },
    /**
     * Export warehouse product stock to excel
     */
    async exportStock() {
      const partnerId = this.partnerId || this.dataPartner?.id
      if (!partnerId) {
        toastError('ID partner tidak ditemukan')
        return
      }

      this.loadingExport = true
      try {
        const response = await this.$http_new.post('/komship/api/v1/product-warehouses/stock-export', null, {
          params: {
            partner_id: partnerId,
          },
          responseType: 'blob',
        })

        const partnerName = this.partnerName || 'Partner'
        const formattedDate = DAY_MONTH_YEAR()
        const warehouseName = this.profile?.warehouse_name || this.profile?.name || 'Gudang'
        const fallbackFilename = `Stock Kompack ${partnerName}, ${formattedDate}, di Gudang ${warehouseName}.xlsx`

        let fileName = response.headers['x-filename'] || fallbackFilename
        if (!fileName.toLowerCase().endsWith('.xlsx')) {
          fileName = `${fileName}.xlsx`
        }

        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(link)

        toastSuccess('File berhasil diunduh ke perangkat Anda.', 'Download Berhasil')
      } catch (error) {
        toastError(error?.response?.data?.message || error?.message || 'Gagal mengunduh file.', 'Download Gagal')
      } finally {
        this.loadingExport = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-collapse {
  background-color: transparent !important;
  color: #08A0F7 !important;
  border: none;
  font-size: 16px;
}
[dir] .when-closed {
  display: inline-block;
}

[dir] .when-opened {
  display: inline-block;
}

@media screen and (max-width: 767px) {
  .table-container {
  overflow-x: scroll;
  }
  .table {
    width: 750px;
    table-layout: fixed;
  }
}
 .collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
    }
</style>
